export function capitalizeEveryWord(string, skipLowercase) {
  if (!string) {
    return string;
  }

  let intermediate = string;
  if (!skipLowercase) {
    intermediate.toLowerCase();
  }

  return intermediate.replace(/(?:[A-Z]|\b\w)/g, letter => letter.toUpperCase());
}

export function simplifyLargeNumber(largeNumber) {
  if (largeNumber === null) return null;

  let formatted = largeNumber + '';
  if (largeNumber > 1000000) {
    formatted = parseFloat(largeNumber / 1000000).toFixed(0) + 'M';
  } else if (largeNumber > 1000) {
    formatted = parseFloat(largeNumber / 1000).toFixed(0) + 'K';
  }
  return formatted;
}




/** WEBPACK FOOTER **
 ** ./src/lib/StringUtils.js
 **/